export enum MenuOption {
	'Create portfolio',
	'Select data points',
	'Select peer group',
}

export enum MenuOptionView {
	'Saved analysis',
	'Create analysis',
}
